import dayjs from 'dayjs';
import {CALENDAR_INPUT_DATE_FORMAT} from '../constants/format-templates';

export const addDaysToDate = (date, numberOfDays) : string => {
  return dayjs(date).add(numberOfDays, 'day').format(CALENDAR_INPUT_DATE_FORMAT);
}